import { useState } from 'react';

import {
  bookingProgress,
  feedbackSubmitted,
  resultSubmissionNotification,
} from '../utils/localStorage';

export const keys = {
  bookingProgress: 'bookingProgress',
  feedbackSubmitted: 'feedbackSubmitted',
  resultSubmissionNotification: 'resultSubmissionNotification',
};
const validKeys = {
  bookingProgress,
  feedbackSubmitted,
  resultSubmissionNotification,
};
const DEFAULT_KEY = 'UNKNOWN_KEY';
function isKeyValid(key) {
  return key in validKeys;
}
function getStorageKey(key, trustProvidedKey = false) {
  if (trustProvidedKey) {
    return key;
  }
  return isKeyValid(key) ? key : DEFAULT_KEY;
}
// courtesy of https://usehooks.com/useLocalStorage/
export function useLocalStorage(key, initialValue, { trustProvidedKey } = {}) {
  const validKey = getStorageKey(key, trustProvidedKey);

  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(validKey);

      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue. add sentry or something
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.localStorage.setItem(validKey, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case add sentry or something
    }
  };

  return [storedValue, setValue];
}
